import styled from '@emotion/styled';
import { BasketItem } from 'store/basket/basketAPI';
import { ExamCard } from 'components';

import { Button } from '@britishcouncil/react-solas';

type ExamItemProps = { exam: BasketItem; onRemove: () => void };

const ExamItem = ({ exam, onRemove }: ExamItemProps) => {
  return (
    <ExamCard exam={exam}>
      <StyledButton intent={'danger'} onClick={onRemove} size="xs">
        Remove
      </StyledButton>
    </ExamCard>
  );
};

export default ExamItem;

const StyledButton = styled(Button)`
  margin-top: 1em;
`;
